<script setup>
import { STATUTS_COMMANDE } from "@/utils/statut-commande";
import { useTransactionFailureTracking } from "@/mixins/tracking/transaction-failure";
import { useTrackingPage } from "@/mixins/tracking/all-pages";
import { loadPageWithLoader } from "@/utils/webpack-helper";
import { useContextStore } from "@/store/context";

definePageMeta({
  middleware: "authenticated",
  layout: "commander"
});

const { trackTransactionFailure } = useTransactionFailureTracking();
const { trackPage } = useTrackingPage();

onBeforeMount(() => {
  trackTransactionFailure(trackingCodes.LABELGA.failure);
  trackPage(trackingCodes.PAGETYPE.orderError);
});

const { layout } = storeToRefs(useContextStore());

const component = computed(() => {
  return loadPageWithLoader(
    lazyComponents[
      `/components/pages/commander/confirmation/error/${layout.value}.vue`
    ]
  );
});
</script>

<template>
  <component
    :is="component"
    :statut="STATUTS_COMMANDE.erreur"
  />
</template>
